import React from 'react';
import moment from 'moment'
import Poll from '../../molecules/Poll/component';

const DateRangeDisplay = ({from, to}) => {
  if ( !(from && to) ) return null;
  const formatIn = "YYYY-MM-DDTHH:mm";
  const fromM = moment(from, formatIn), toM = moment(to, formatIn);
  const sameMonth = fromM.format("MM") === toM.format("MM");
  const sameYear = fromM.format("YYYY") === toM.format("YYYY");
  return (
    <span>
      <span>{fromM.format("ddd Do" + (sameMonth ? "" : " MMM"))}</span>
      {" "}
      to
      {" "}
      <span>{toM.format("ddd Do MMM" + (sameYear ? "" : "'YY"))}</span>
    </span>
  );
};

class AgendaPoll extends Poll {

  renderChoiceHeader(choice) {
    return (
      <DateRangeDisplay from={choice.from} to={choice.to}/>
    )
  }

  render() {
    const {options, type} = this.props;

    if ( type !== "dates" ) return null;
    const responded = Object.keys(this.state.userResponses).filter(id => typeof this.state.userResponses[id] !== "undefined").length;
    const total = Object.keys(options).length;
    return this.wrap("AgendaPoll", (
      <div className="intro">
        <p> Please select which dates you can attend </p>
        <small>{responded}/{total} responses</small>
      </div>
    ), responded === total ? (
      <p className="footer"> Thank you </p>
    ) : undefined);

  }

};

export default AgendaPoll;



// WEBPACK FOOTER //
// ./src/component/molecules/AgendaPoll/component.js